import React from 'react'
import ConfirmOrderTable from './ConfirmOrderTable'
import Specifications from './Specifications'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { ReviewAndConfirmProp } from '@src/routes/Configurators/components/ConfiguratorTypes'

const ReviewAndConfirm: React.FC<ReviewAndConfirmProp> = ({
  productDetails,
  itemDetails,
  instructions,
  currencyFormat,
  thousandSeparator,
  thousandSpacing,
  prefixCurrecny: prefixCurrency,
  decimalSeparator,
}) => {
  const [open, setOpen] = React.useState<boolean>(false)
  const [message, setMessage] = React.useState<string>('')

  const updateError = (value: string) => {
    setOpen(true)
    setMessage(value)
  }
  return (
    <>
      <div>
        <ErrorAlert open={open} setOpen={setOpen} message={message} />
      </div>
      <div>
        <ConfirmOrderTable
          productDetails={productDetails}
          instructions={instructions}
          currencyFormat={currencyFormat}
          thousandSeparator={thousandSeparator}
          thousandSpacing={thousandSpacing}
          prefixCurrecny={prefixCurrency}
          decimalSeparator={decimalSeparator}
        />
        <Specifications
          productDetails={productDetails}
          itemDetails={itemDetails}
          currencyFormat={currencyFormat}
          updateError={updateError}
          thousandSeparator={thousandSeparator}
          thousandSpacing={thousandSpacing}
          prefixCurrency={prefixCurrency}
          decimalSeparator={decimalSeparator}
        />
      </div>
    </>
  )
}

export default ReviewAndConfirm
